import { Outlet } from "react-router";
import Header from "../header/Header";

export default function Layout() {
  return (
    <div className="flex h-svh flex-col">
      <Header />

      <div className="mx-auto w-full max-w-(--breakpoint-2xl) flex flex-1 px-4 lg:px-6">
        <Outlet />
      </div>
    </div>
  );
}
